module.exports = __webpack_public_path__ + "img/dashboard-icon-white.293ce241.svg";